import ApplicationInstance from '@ember/application/instance';
import Service from '@ember/service';
import { OAuthOpenOptions, OAuthOpenResponse, OAuthProvider } from 'cio/utils/oauth';
import { Provider } from 'cio/utils/oauth';

export type ProviderMap = Record<Provider, OAuthProvider>;

export default class OAuthService extends Service {
  readonly providers: ProviderMap;

  constructor(owner: ApplicationInstance) {
    super(owner);

    // Loop through the providers established in the Provider enum, find them
    // in the app structure (must be in `oauth-providers` folder!), and then
    // init the class from the default export therein. If it isn't found, throw
    // an error early.
    let providers = Object.values(Provider).reduce<ProviderMap>((acc, provider: Provider) => {
      let ProviderClass = owner.resolveRegistration(`oauth-provider:${provider}`) as { new (): OAuthProvider };

      if (ProviderClass == null) {
        throw new Error(`OAuth provider ${provider} was not found. Does the provider name match the file name?`);
      }

      return {
        ...acc,
        [provider]: new ProviderClass(),
      };
    }, {} as ProviderMap);

    this.providers = providers;
  }

  open<Options extends OAuthOpenOptions>(provider: Provider, options?: Options): Promise<OAuthOpenResponse> {
    let oauthProvider = this.providers[provider];

    return oauthProvider.open(options);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    oauth: OAuthService;
  }
}
